import { motion } from 'framer-motion'
import React from 'react'

const PlanDetailsLoader = () => {
    return <motion.div className="w-full h-full bg-white rounded-lg flex flex-col">
        <motion.div className="flex flex-row w-full items-center px-2 py-2 justify-start">
            <p className="text-black font-bold text-md">
                <span className='w-32 h-5 animate-pulse bg-primeColor/20 rounded-lg'></span>
            </p>&nbsp;:&nbsp;<p className="text-primeColor font-bold text-xl">
                <span className='w-32 h-5 animate-pulse bg-primeColor/20 rounded-lg'></span>
            </p>
        </motion.div>
        <motion.div className="flex flex-row w-full items-center px-2 py-2 justify-start">
            <p className="text-black font-bold text-md">
                <span className='w-32 h-5 animate-pulse bg-primeColor/20 rounded-lg'></span>
            </p>&nbsp;:&nbsp;<p className="text-primeColor font-bold text-xl">
                <span className='w-10 h-5 animate-pulse bg-primeColor/20 rounded-lg'></span>
            </p>
        </motion.div>
        <motion.div className="flex flex-row w-full items-center px-2 py-2 justify-start">
            <p className="text-black font-bold text-md">
                <span className='w-32 h-5 animate-pulse bg-primeColor/20 rounded-lg'></span>
            </p>&nbsp;:&nbsp;<p className="text-primeColor font-bold text-xl">
                <span className='w-10 h-5 animate-pulse bg-primeColor/20 rounded-lg'></span>
            </p>
        </motion.div>
        <motion.div className="flex flex-row w-full items-center px-2 py-2 justify-start">
            <p className="text-black font-bold text-md">
                <span className='w-32 h-5 animate-pulse bg-primeColor/20 rounded-lg'></span>
            </p>&nbsp;:&nbsp;<p className="text-primeColor font-bold text-xl">
                <span className='w-32 h-5 animate-pulse bg-primeColor/20 rounded-lg'></span>
            </p>
        </motion.div>
    </motion.div>
}

export default PlanDetailsLoader